import {
  timeSecond,
  timeMinute,
  timeHour,
  timeDay,
  timeWeek,
  timeMonth,
  timeYear,
} from 'd3-time';

import {
  timeFormat,
  timeParse,
  utcFormat,
  utcParse,
  isoParse,
} from 'd3-time-format';
/**
 A multi-scale time formatter.
 **/
function multiFormat(utc, date) {
  let fmt;
  if (timeSecond(date) < date) {
    fmt = '.%L';
  } else if (timeMinute(date) < date) {
    fmt = ':%s';
  } else if (timeHour(date) < date) {
    fmt = '%I:%M';
  } else if (timeDay(date) < date) {
    fmt = '%I %p';
  } else if (timeMonth(date) < date) {
    fmt = timeWeek(date) < date ? '%a %d' : '%b %d';
  } else if (timeYear(date)) {
    fmt = '%B';
  } else {
    fmt = '%Y';
  }
  return utc
    ? utcFormat(fmt)(date)
    : timeFormat(fmt)(date);
}

/**
 Format a time. A lighter-weight alternative to using moment.
 @param {Date|Number|String} value - The value to be formatted.
 @param {String} [fmt] - The format for display. If not given, the default d3
 multiscale format is used. See d3-time-format for details on the syntax.
 @param {String} [parseFmt] - The format for parsing string values. If not
 defined, string values are assumed to be in ISO 8601 format.
 @param {Boolean} [utc=false] - If true, the directives are interpreted as UTC.
 @return {String} The formatted date.
 **/
function formatTime(value, fmt, parseFmt, utc = false) {
  let formatter;
  if (fmt && utc) {
    formatter = utcFormat(fmt);
  } else if (fmt) {
    formatter = timeFormat(fmt);
  } else {
    formatter = multiFormat.bind(null, utc);
  }

  let parser;
  if (typeof value === 'string') {
    if (parseFmt && utc) {
      parser = utcParse(parseFmt);
    } else if (parseFmt) {
      parser = timeParse(parseFmt);
    } else {
      parser = isoParse;
    }
  } else {
    parser = (x) => x;
  }

  return formatter(parser(value));
}

export default formatTime;
